import type { FC } from "react";
import type { TileType } from "../types";
import Glyph from "./Glyph";
import LevelGlyph from "./LevelGlyph";
import Mascot from "./Mascot";
import RewardGlyph from "./RewardGlyph";

type Props = {
  type: TileType;
  level?: number;
  tierName?: string;
};

const TileGlyph: FC<Props> = ({ type, level, tierName }) => {
  if (type === "rakeback") return <RewardGlyph name="rakeback" />;
  if (type === "cashback") return <RewardGlyph name="cashback" />;
  if (type === "levelUp") return <LevelGlyph level={level ?? 1} />;
  if (type === "tierUp" && tierName) return <Mascot tierName={tierName} />;
  if (type === "monthlyBonus") return <Glyph name="allRewards" />;
  return null;
};

export default TileGlyph;
